import { all, call, put, SagaIterator, takeEveryCompletedRequest, takeEveryErrorRequest } from './core/sagaEffects';
import { ItineraryPdfUrlRequest, QuotePdfUrlRequest } from 'acscp/api/requests';
import { FileUrl } from 'acscp/api/models/fileUrl';
import { AddNotification } from 'acscp/actions';
import { ResponseType } from 'acscp/api/responses/core/responseTypes';
import { ErrorDetails } from 'acscp/api/models/errorDetails';
import { defineMessages } from 'react-intl';
import { NotificationType } from 'acscp/store/notificationState';
import { AppLauncher } from '@capacitor/app-launcher';

const messages = defineMessages({
    pdfOpeningFailed: {
        id: 'sagas.pdfHandlingSaga.openPdfError',
        defaultMessage: 'Failed to open PDF.',
    },
});

const PdfOpeningFailedCause = 'PdfOpeningFailedCause';

export function* pdfHandlingSaga(): SagaIterator {
    yield all([
        takeEveryCompletedRequest(ItineraryPdfUrlRequest, openPdf),
        takeEveryCompletedRequest(QuotePdfUrlRequest, openPdf),

        takeEveryErrorRequest(ItineraryPdfUrlRequest, handlePdfErrors),
        takeEveryErrorRequest(QuotePdfUrlRequest, handlePdfErrors),
    ]);
}

function* openPdf(response: FileUrl, request: ItineraryPdfUrlRequest | QuotePdfUrlRequest): SagaIterator {
    if (OPEN_FILES_AS_MOBILE) {
        yield call(AppLauncher.openUrl, {url: response.url}); // external browser
    } else {
        // Use the file ID as the window target.
        // This targets an already created by "View PDF" button window
        yield call(window.open, response.url, request.id);
    }
}

function* handlePdfErrors(
    responsType: ResponseType,
    error: ErrorDetails,
    request: ItineraryPdfUrlRequest | QuotePdfUrlRequest
): SagaIterator {

    if (!OPEN_FILES_AS_MOBILE) {
        // File ID was used as the window target - use it to close the window.
        yield call(closeWindowWithTarget, request.id);
    }
    yield put(new AddNotification(PdfOpeningFailedCause, messages.pdfOpeningFailed, NotificationType.Error));
}

function closeWindowWithTarget(windowTarget: string): void {
    const windowHandle = window.open('', windowTarget);

    if (windowHandle) {
        windowHandle.close();
    }
}
